import React, { useState, useEffect, useContext, useRef } from "react";
// import { useState } from 'react'
import { userContext } from "../../context/userContext";
import axios from "axios";
import { data } from "jquery";
import { environmentVariables } from "../../config/env.config";
// import { cp } from "fs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import Cookies from "js-cookie";
import "././Updatedcss/ProfileUpdateStyle.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getcoutryfromlocation, isValidPhoneNumber } from "../../utils/utility";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import BankDetails from './BankDetails'

// import { baseUrl } from "./config";

function Profile() {
  const { t } = useTranslation();
  const { userData, setUserData } = useContext(userContext);
  const navigate = useNavigate();
  const baseUrl = environmentVariables?.apiUrl;
  const [editedData, setEditedData] = useState({
    name: userData?.name || "",
    // lastname: userData?.lastname || '',
    email: userData?.email || "",
    contact: `${userData?.country_code || ''}-${userData?.contact || ''}`,
  });
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");
  const [oPVisibility, setOPVisibility] = useState(false);
  const [pVisibility, setPVisibility] = useState(false);
  const [cpVisibility, setCPVisibility] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [invalidPhoneErr, setInvalidPhoneErr] = useState("");
  const [countryCode, setCountryCode] = useState("in");
  const [sessionData, setSessionData] = useState("");
  const [kycActive , setKYCActive] = useState(false)
  const location = useLocation();
  const { activelink } = location.state || {};

   useEffect(() => {
    if (activelink) {
      setActiveTab(activelink);
    }
  }, [activelink]);

  const fetchCountryfromlocation = async () => {
    try {
      const countryData = await getcoutryfromlocation();
      setCountryCode(countryData.countryCode.toLowerCase());
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  useEffect(() => {
    fetchCountryfromlocation()
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleKYCTabClick = (tab)=>{
setActiveTab(tab);
handleStartKYC();
  }
  const [countryName, setCountryName] = useState("");

  // frontend validation
  const validateSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .required(t("Please_enter_old_password"))
      .min(8, t("Password_at_least_8_characters"))
      .matches(/[0-9]/, t("Password_at_least_1_digit_character"))
      .matches(
        /[a-z]/,
        t("Password_at_least_1_lowercase_character")
      )
      .matches(
        /[A-Z]/,
        t("Password_at_least_1_uppercase_character")
      ),
    password: Yup.string()
      .required(t("Please_enter_new_password"))
      .min(8, t("Password_at_least_8_characters"))
      .matches(/[0-9]/, t("Password_at_least_1_digit_character"))
      .matches(
        /[a-z]/,
        t("Password_at_least_1_lowercase_character")
      )
      .matches(
        /[A-Z]/,
        t("Password_at_least_1_uppercase_character")
      ),
    confirmPassword: Yup.string()
      .required(t("Please_re-type_new_password"))
      .oneOf([Yup.ref("password")], t("Passwords_does_not_match")),
  });

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: validateSchema,
    onSubmit: (values, { resetForm }) => {
      setIsSubmit(true);
      handleChanePassword(values);
    },
  });

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const nameRegex = /^[A-Za-z\s]+$/;
      // setIsSubmit(true);
      // console.log(userData,"userDatauserDatauserData")
      if (editedData?.name == "" || editedData?.name?.trim() == "") {
        toast.error(t("Name_is_mandatory"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        return;
      } else if (!nameRegex.test(editedData?.name)) {
        toast.error(t("Name_only_alphabetic_characters"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        return;
      } else if (
        editedData?.name?.length > 40 ||
        editedData?.name?.trim()?.length > 40
      ) {
        toast.error(t("Name_maximum_40_character"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        return;
      } else if (
        editedData?.name?.length < 3 ||
        editedData?.name?.trim()?.length < 3
      ) {
        toast.error( t("Name_minimum_3_character"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        return;
      }
      if(editedData?.contactNumber == "" || editedData?.contactNumber?.trim() == ""){
        toast.error(t("Contact_number_is_mandatory"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        return;
      }
      if (editedData?.contact == "" || editedData?.contact?.trim() == "") {
        toast.error(t("Contact_number_is_mandatory"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        return;
      }
      
      if (invalidPhoneErr) {
        toast.error(invalidPhoneErr, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setIsSubmit(false);
        return;
      }

      let countryCode = '';
      let contactNumber = '';
      if(!!editedData?.contact){
        let contactArr = editedData?.contact?.split("-");
        countryCode = contactArr?.length > 0? contactArr[0]:"";
        contactNumber = contactArr?.length > 0? contactArr[1]:"";
      }
      // // let contactNumber = editedData?.contact.replace(/-/g, '');
      // console.log("contactNumber====>>>", );
      
      // if (contactNumber.startsWith('+91')) {
      //   countryCode = '+91';
      //   contactNumber = contactNumber.slice(3);
      // } else if (contactNumber.startsWith('+971')) {
      //   countryCode = '+971';
      //   contactNumber = contactNumber.slice(4);
      // } else if (contactNumber.startsWith('+1')) {
      //   countryCode = '+1';
      //   contactNumber = contactNumber.slice(2);
      // } else if (contactNumber.startsWith('+964')) {
      //   countryCode = '+964';
      //   contactNumber = contactNumber.slice(4);
      // } else if (contactNumber.startsWith('+44')) {
      //   countryCode = '+44';
      //   contactNumber = contactNumber.slice(3);
      // } else if (contactNumber.startsWith('+960')) {
      //   countryCode = '+960';
      //   contactNumber = contactNumber.slice(4);
      // } else {
      //   toast.error(t("Unsupported_country_code"), {
      //     position: toast.POSITION.TOP_RIGHT,
      //     autoClose: 2000,
      //   });
      //   return;
      // }
      
      
      let config = {
        method: "put",
        url: `${baseUrl}api/v1/user/${userData?.user_type == "super_admin" ? "updateUser" : "updateNormalUser"
          }`,
        headers: {
          _token: userData?.token,
          "Content-Type": "application/json",
        },
        // withCredentials: true,
        data: {
          userId: userData?.id,
          name: editedData?.name,
          email: editedData?.email,
          contact: contactNumber,
          country_code: countryCode,
          profile:1
        },
      };

      axios
        .request(config)
        .then((response) => {
          setIsSubmit(false);
          let updatedUserData = {
            ...userData,
            name: editedData?.name || userData?.name,
            email: editedData?.email || userData?.email,
            contact: contactNumber || userData?.contact,
            country_code: countryCode || userData?.country_code,
          };



          setUserData(updatedUserData);
          localStorage.setItem("user", JSON.stringify(updatedUserData));

          // console.log(obj, "setUserDatasetUserDatasetUserData");
          toast.success(t("Your_profile_updated_successfully"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        })
        .catch((error) => {
          setIsSubmit(false);
          console.error(
            "Update User API Error:",
            error?.response?.data?.message
          );
          toast.error(
            error?.response?.data?.message ||
            t("Failed_to_update_your_profile"),
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            }
          );
        });
    } catch (error) {
      setIsSubmit(false);
      console.error("API Error:", error);
      toast.error(t("An_unexpected_error_occurred"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  };

  const handleChanePassword = async (data) => {
    try {
      if (userData?.user_type === "super_admin" || userData?.user_type === "Super Admin") {
        let config = {
          method: "post",
          url: `${baseUrl}api/v1/user/createsuperAdminotp`,
          headers: {
            _token: userData?.token,
            "Content-Type": "application/json",
          },
          data: {
            oldpassword: data.oldPassword,
            password: data.password,
            cpassword: data.confirmPassword,
          },
        };
  
        axios
          .request(config)
          .then((response) => {
            console.log(response, "response ==>");
            setIsSubmit(false);

            Swal.fire({
              title: t("Otp"),
              text: t("Please_enter_otp"),
              input: "text",
              inputAttributes: {
                autocapitalize: "off",
                inputmode: "numeric",
                pattern: "[0-9]{6}",
                maxLength: 6,
              },
              inputValidator: (value) => {
                if (!value || !/^[0-9]{6}$/.test(value)) {
                  return t("Please_enter_valid_6-digit_otp");
                }
              },
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: t("Submit"),
              cancelButtonText: t("Cancel"),
              allowOutsideClick: false,
              allowEscapeKey: false,
              showLoaderOnConfirm: true,
              preConfirm: (otp) => {
                const otpValue = otp;
                let configOtp = {
                  method: "post",
                  maxBodyLength: Infinity,
                  withCredentials: true,
                  url: `${environmentVariables?.apiUrl}api/v1/user/changePassword`,
                  headers: {
                    _token: userData?.token,
                    "Content-Type": "application/json",
                  },
                  data: { 
                    oldpassword: data.oldPassword,
                    password: data.password,
                    cpassword: data.confirmPassword, 
                    otp_code: otpValue },
                };
                return axios
                  .request(configOtp)
                  .then((res) => {
                    toast.success(t("Password_updated_successfully"));
                    setTimeout(async () => {
                      await logout();
                      navigate("/");
                    }, 1500);
                    return;
                  })
                  .catch((err) => {
                    console.log("error", err);
                    Swal.showValidationMessage(
                      `Failed: ${err?.response?.data?.message}`
                    );
                  });
              },
            });

          })
          .catch((error) => {
            setIsSubmit(false);
            toast.error(
              error.response?.data?.message ||
                  t("Failed_to_send_otp"),
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              }
            );
          });
      } else {
        callChangePasswordAPI(data);
      }
    } catch (error) {
      setIsSubmit(false);
      toast.error(t("An_unexpected_error_occurred"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  };

  const callChangePasswordAPI = (data) => {
    let config = {
      method: "post",
      url: `${baseUrl}api/v1/user/changePassword`,
      headers: {
        _token: userData?.token,
        "Content-Type": "application/json",
      },
      data: {
        oldpassword: data.oldPassword,
        password: data.password,
        cpassword: data.confirmPassword,
      },
    };
  
    axios
      .request(config)
      .then((response) => {
        setIsSubmit(false);
        toast.success(t("Password_updated_successfully"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setTimeout(async () => {
          await logout();
          navigate("/");
        }, 1500);
      })
      .catch((error) => {
        setIsSubmit(false);
        toast.error(
          error.response?.data?.message ||
            t("Failed_to_update_password"),
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          }
        );
      });
  };

  const logout = () => {
    const loginFormData = localStorage.getItem("login_form");
    localStorage.clear();
    if (loginFormData !== null) {
      localStorage.setItem("login_form", loginFormData);
    }
    setUserData(null);
    return true;
  };
  const toggleOPasswordVisibility = () => {
    setOPVisibility(!oPVisibility);
  };
  const togglePasswordVisibility = () => {
    setPVisibility(!pVisibility);
  };
  const toggleCPasswordVisibility = () => {
    setCPVisibility(!cpVisibility);
  };

  const handleBlur = (value, phoneData) => {    
    phoneData.iso2 = phoneData.countryCode;
    let contactNumber = editedData.contact;
    if (!!contactNumber) {
      let val = contactNumber.split("-");
      let valArray = val.length > 0 ? val[1] : "";
      if (valArray == '') {
        setInvalidPhoneErr(t("Please_enter_number"));
      } else if (!isValidPhoneNumber(valArray, phoneData)) {
        setInvalidPhoneErr(`Invalid phone number for ${phoneData.name}`);
      } else {
        setInvalidPhoneErr("");
      }
    }
  };


  // const startVeriff = async() => {
  //   if (window.Veriff) {
  //     const res = await axios.post(`${baseUrl}api/v1/kyc/create_session`, {
  //       userId: "123",
  //       firstName: "Tanuj",
  //       lastName: "Kumar",
  //     });
    
  //     console.log("res", res?.data);
  //     const sessionUrl = res?.data?.url;
  //     console.log("sessionUrl", sessionUrl);

  //     const veriff = window.Veriff({
  //       apiKey: 'e0bf8f20-ff4b-4047-b374-0e2a4caad636', // Replace with your Veriff API key
  //       parentId: 'veriff-root',
  //       sessionURL: sessionUrl,
  //       onSession: function (err, response) {
  //         if (err) {
  //           console.error('Veriff session error:', err);
  //           return;
  //         }
  //         console.log('Veriff session response:', response);
  //       },
  //     });

  //     veriff.mount();
  //   } else {
  //     console.error('Veriff SDK not loaded yet.');
  //   }
  // };
  const [loading, setLoading] = useState(false);
  const [sessionUrl, setSessionUrl] = useState('');
  const [error, setError] = useState('');
  const [showKyc, setShowKYC] = useState(true);
  const [sessionContent, setSessionContent] = useState("");
  const [duplicateKYC, setDuplicateKYC] = useState(false);
  const veriffContainerRef = useRef(null);

  const handleStartKYC = async () => {
    setLoading(true);
    setKYCActive(true)
    setError('');
    const existingSessionId = localStorage.getItem("kyc_session_id");
    try {
     
      if(existingSessionId){
        const resumeResponse = await axios.get(`${baseUrl}api/v1/kyc/get_session?user_id=${userData?.id}`);
        console.log(resumeResponse?.data,"resumeResponse?.data")
        const { sessionUrl, verifyStatus } = resumeResponse?.data?.data;

        console.log("url", sessionUrl,resumeResponse?.data,verifyStatus)
        if (verifyStatus != "declined") {
          console.log("Resuming KYC session:", existingSessionId);
          setLoading(false);
          window.location.href = sessionUrl;
          return;
        } else {
          localStorage.removeItem("kyc_session_id");
        }

      }
      // const sessionUrl = response.data.url;
      // setSessionUrl(sessionUrl);

     
     
    } catch (err) {
      console.error(err);
      setLoading(false);
      setKYCActive(false)
    }

    try {
       const veriff = window.Veriff({
        apiKey: environmentVariables?.veriffKey, 
        parentId: 'veriff-root',
        // sessionURL: sessionUrl,
        onSession: async function (err, response) {
          if (err) {
            console.error('Veriff session error:', err);
            setError('Failed to start KYC session');
            return;
          }
          try {
            console.log('Tanuj111', sessionData);

              const { host, id, sessionToken, url, vendorData } = response?.verification
              localStorage.setItem("kyc_session_id", id);
              const responseFromApi = await axios.post(`${baseUrl}api/v1/kyc/create_session`, {
                host,
                session_id : id,
                sessionToken,
                url,
                vendorData : vendorData?.trim(),
                user_id : userData?.id?.toString(),
              });
              console.log("response", responseFromApi?.data);
              console.log('Veriff session response:12', response?.verification);
              setLoading(false)
              window.location.href = url;

              // incontext sdk
              // createVeriffFrame({url: response.verification.url});
          } catch (error) {
            console.error(error);
            setLoading(false)
            setKYCActive(true)
            setError(error?.response?.data?.message || response?.message || 'Something went wrong');
          }
        }
      });
      veriff.setParams({
        person: {
          givenName: ' ',
          lastName: ' '
        },
        vendorData: ' '
      });

       veriff.mount({
          submitBtnText: 'Get verified'
        });
    } catch (error) {
       console.error(err);
      setError('Something went wrong starting the session');
    }

    setLoading(false);
    setKYCActive(true)
  };

  useEffect(() => {
  const checkExistingSession = async () => {
    // const existingSessionId = localStorage.getItem("kyc_session_id");
    // if (!existingSessionId) {
    //   setShowKYC(false);
    //   return;
    // };

    try {
      const resumeResponse = await axios.get(`${baseUrl}api/v1/kyc/get_session?user_id=${userData?.id}`);
      const { verifyStatus, custom_reason } = resumeResponse?.data?.data;
      console.log("custom_reason,",custom_reason,verifyStatus,userData?.id)
      if(custom_reason){
        setDuplicateKYC(true)
      }else{
        if (verifyStatus === "approved") {
          setShowKYC(false);
          setSessionContent("approved")
          localStorage.removeItem("kyc_session_id");
        }else if(verifyStatus == "declined"){
          setShowKYC(false);
          setSessionContent("declined")
        }
      }


      
    } catch (err) {
      console.error("Error checking existing session:", err);
    }
    };

    checkExistingSession();
  }, []);

  // const veriffRef = useRef(null); // Reference to the root div

  // useEffect(() => {
  //   // Dynamically load the Veriff SDK
  //   const script = document.createElement('script');
  //   script.src = 'https://cdn.veriff.me/sdk/js/1.5/veriff.min.js';
  //   script.async = true;

  //   script.onload = () => {
  //     if (window.Veriff) {
  //       const veriff = window.Veriff({
  //         apiKey: 'e0bf8f20-ff4b-4047-b374-0e2a4caad636',
  //         parentId: 'veriff-root',
  //         onSession: function (err, response) {
  //           if (err) {
  //             console.error('Veriff session error:', err);
  //             return;
  //           }
  //           console.log('Veriff session response:', response);
  //           window.location.href = response.verification.url;
  //           // You can now trigger verification if needed
  //         },
  //       });

  //       veriff.mount();
  //     }
  //   };

  //   document.body.appendChild(script);

  //   // Clean up: remove script and unmount Veriff
  //   return () => {
  //     document.body.removeChild(script);
  //     if (veriffRef.current) {
  //       veriffRef.current.innerHTML = ''; // Clean the container
  //     }
  //   };
  // }, []);


  // let getSessionData = async () => {
  //   try {
  //   let getLocalStorageData = localStorage.getItem("kyc_session_id");
    
  //   let config = {
  //     method: 'get',
  //     url: `${baseUrl}api/v1/kyc/get_session?session_id=${getLocalStorageData}`,
  //     headers: { 
  //       '_token': userData?.token, 
        // 'Content-Type': 'text/plain'
  //     },
  //   };
  //     const responseData = await axios.request(config);
  //     console.log("responseData", responseData,responseData?.status);
  //     setSessionData(responseData?.data?.data);
  //   } catch (error) {
  //     console.log("error", error);
  //     setSessionData("")
  //   }
  // }
  // useEffect(() => {
  //   getSessionData()
  // }, []);

  return (
    <>
      <div className="row ProfileContainer">
        <div className="col-md-4 ProfileWrapper  ">
          <div className="tile">
            <ul className="conatctprofile ProfileflexContainer">
              <li
                className={`tab-item ${activeTab === "tab1" ? "active" : ""}`}
                onClick={() => handleTabClick("tab1")}
                id="PersonalInput"
              >
                {t("Personal_info")}
              </li>
              <li
                className={`tab-item ${activeTab === "tab2" ? "active" : ""}`}
                onClick={() => handleTabClick("tab2")}
                id="PersonalInput"
              >
                {t("Change_password")}
              </li>
              {
                userData?.user_type !== "super_admin" && duplicateKYC && (
                <div
                >
                  {t("Duplicate_KYC")}
                </div>
                )
              }
             
             
              {
                userData?.user_type !== "super_admin" &&( sessionContent=="approved" ?  
                  <li
                style={{opacity:"0.5"}}
                id="PersonalInput"
              >
              <i class="fa-solid fa-circle-check" style={{color: "green", marginRight:"10px" ,fontSize:"20px"}}></i>
              KYC Verified
              </li>  : 
                  // sessionContent=="declined" ? <p onClick={handleStartKYC}>Declined</p> : 
                  (
                     <li
                className={`tab-item ${activeTab === "tab3" ? "active" : ""}`}
                onClick={() => handleTabClick("tab3")}
                id="PersonalInput"
              >
                {t("Verify Identity (KYC)")}
              </li> )
                )
              }

               {/* <li
                className={`tab-item ${activeTab === "tab4" ? "active" : ""}`}
                onClick={() => handleTabClick("tab4")}
                id="PersonalInput"
              >
                {t("Business_verification")}
              </li> */}
              <li
                className={`tab-item ${activeTab === "tab5" ? "active" : ""}`}
                onClick={() => handleTabClick("tab5")}
                id="PersonalInput"
              >
                {t("bank_details")}
              </li>
              
            </ul>
          </div>
        </div>
        <div className="col-md-8 ProfileWrapper">
          <div className="tile">
            {activeTab === "tab1" && (
              <form>
                <div className="row mb-4">
                  <div className="col-md-6 ProfileNameWid">
                    <label className="profileLabel">Name</label>
                    <input
                      className="form-control"
                      placeholder={t("Name")}
                      type="text"
                      value={editedData.name}
                      onChange={(e) =>
                        setEditedData({ ...editedData, name: e.target.value })
                      }
                    />
                  </div>
                  {/* <div className="col-md-6">
                    <label>Last Name</label>
                    <input className="form-control" type="text" value={editedData?.lastname || ''}
                    onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}/>
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <label className="profileLabel">Email</label>
                    <input
                      placeholder={t("Email")}
                      className="form-control"
                      type="text"
                      value={editedData?.email || ""}
                    />
                  </div>
                  <div className="clearfix"></div>
                  <div className="col-md-12 mb-4"> 
                    <label className="profileLabel">Phone Number</label>                
                    <PhoneInput
                      country={countryCode}
                      enableSearch={true}
                      countryCodeEditable={false}
                      value={editedData.contact || ""}
                      onChange={(value, country) => {
                        if (country.dialCode) {
                          setEditedData({
                            ...editedData,
                            countryCode: country.dialCode,
                            contactNumber: value.substring(
                              country.dialCode.length
                            ),
                            contact: `+${country.dialCode}-${value.substring(
                              country.dialCode.length
                            )}`,
                          });
                          setInvalidPhoneErr("");
                        } else {
                          setEditedData({
                            ...editedData,
                            contact: value,
                          });
                          setInvalidPhoneErr("");
                        }
                      }}
                      onBlur={(e, country) => handleBlur(e, country)}
                      isValid={(inputNumber, country) =>
                        isValidPhoneNumber(inputNumber, country)
                      }
                      className="DetailsInfoPhoneInput"
                    />
                    {invalidPhoneErr && (
                      <div id="error_msg" className="">
                        {invalidPhoneErr}
                      </div>
                    )}
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="row mb-10">
                  <div className="col-md-12 ProfileUpdatedButtonContainer">
                    <button
                      className="btn btn-primary ProfileUpdatedButton"
                      type="button"
                      onClick={(e) => handleSave(e)}
                    >
                      {/* <i className="bi bi-check-circle-fill me-2"></i>  */}
                      {/* {isSubmit ? <CircularLoader size={20} /> : "Update"} */}
                      {t("Update")}
                    </button>
                  </div>
                </div>
                <ToastContainer />
              </form>
            )}
            {activeTab === "tab2" && (
              <>
                <form onSubmit={formik.handleSubmit}>
                  <div className="row mb-4 UpdatePasswordWrapper">
                    <div className="col-md-6 ProfileChangepassWid" style={{position:"relative"}}>
                      {/* <label>Password</label> */}
                      <input
                        id="oldPassword"
                        name="oldPassword"
                        className="form-control "
                        placeholder= {t("Enter_old_password")}
                        type={oPVisibility ? "text" : "password"}
                        onChange={formik.handleChange}
                        value={formik.values.oldPassword}
                        
                      />
                      <span
                        onClick={toggleOPasswordVisibility}
                        style={{
                          position: "absolute",
                          right: "45px",
                          top: "32px",
                          // top:  formik.touched.password && formik.errors.password ? "11%" : "15%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        {formik.values.oldPassword.length >= 1 &&
                          (oPVisibility ? (
                            <i className="fas fa-eye Eeye"></i>
                          ) : (
                            <i className="fas fa-eye-slash Eeye"></i>
                          ))}
                      </span>
                      {formik.touched.oldPassword &&
                        formik.errors.oldPassword && (
                          <p className="text-danger passworderrmsg">
                            {formik.errors.oldPassword}
                          </p>
                        )}
                    </div>
                    <div className="col-md-6 ProfileChangepassWid"    style={{position:"relative"}}>
                      {/* <label>Password</label> */}
                      <input
                        id="password"
                        name="password"
                        className="form-control "
                        placeholder= {t("Enter_new_password")}
                        type={pVisibility ? "text" : "password"}
                        onChange={formik.handleChange}
                        value={formik.values.password}
                     
                      />
                      <span
                        onClick={togglePasswordVisibility}
                        style={{
                          position: "absolute",
                          right: "45px",
                          top: "32px",
                          // top: "38%",
                          // top:  formik.touched.password && formik.errors.password ? "37%" : "39%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        {/* {pVisibility ? (
                          <i className="fas fa-eye Eeye"></i>
                        ) : (
                          <i className="fas fa-eye-slash Eeye"></i>
                        )} */}
                        {formik.values.password.length >= 1 &&
                          (pVisibility ? (
                            <i className="fas fa-eye Eeye"></i>
                          ) : (
                            <i className="fas fa-eye-slash Eeye"></i>
                          ))}
                      </span>
                      {formik.touched.password && formik.errors.password && (
                        <p className="text-danger passworderrmsg">{formik.errors.password}</p>
                      )}
                    </div>
                    <div className="col-md-6 ProfileChangepassWid"  style={{position:"relative"}}>
                      {/* <label>Confirm Password</label> */}
                      <input
                        id="confirmPassword"
                        name="confirmPassword"
                        className="form-control"
                        placeholder= {t("Confirm_new_password")}
                        type={cpVisibility ? "text" : "password"}
                        onChange={formik.handleChange}
                        value={formik.values.confirmPassword}
                        style={{position:"relative"}}
                      />
                      <span
                        onClick={toggleCPasswordVisibility}
                        style={{
                          position: "absolute",
                          right: "45px",
                          top: "32px",
                          // top: "63%",
                          // top:  formik.touched.password && formik.errors.password ? "58%" : "63%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        {/* {cpVisibility ? (
                          <i className="fas fa-eye Eeye"></i>
                        ) : (
                          <i className="fas fa-eye-slash Eeye"></i>
                        )} */}
                        {formik.values.confirmPassword.length >= 1 &&
                          (cpVisibility ? (
                            <i className="fas fa-eye Eeye"></i>
                          ) : (
                            <i className="fas fa-eye-slash Eeye"></i>
                          ))}
                      </span>
                      {formik.touched.confirmPassword &&
                        formik.errors.confirmPassword && (
                          <p className="text-danger passworderrmsg">
                            {formik.errors.confirmPassword}
                          </p>
                        )}
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="col-md-12 ProfileUpdatedButtonContainer">
                      <button
                        className="btn btn-primary ProfileUpdatedButton"
                        type="submit"
                      >
                        <i className="bi bi-check-circle-fill me-2"></i>
                        {isSubmit ? <CircularLoader size={20} /> : t("Update")}
                      </button>
                    </div>
                  </div>
                  <ToastContainer />
                </form>
              </>
            )}
              {activeTab === "tab3" && (
                <div className="KYCSection">
               <p>Start your KYC Verification</p>
                <button className="startKYC" onClick={handleStartKYC} style={{opacity: kycActive ? '0.5' :"1"}} disabled={kycActive}>
                  {loading ? 'Starting...' : 'Get Started With KYC'}
                </button>

                {error && <p style={{ color: 'red' }}>{error}</p>}

                <div id="veriff-root" ref={veriffContainerRef} style={{ maxWidth: "350px", marginTop: '20px' }}></div>
              </div>
            )}

             {activeTab === "tab4" && (
                <div className="businessVerification">
                  <h6>Add Business Details</h6>
               <form>
                
                  <div className="col-md-6 ProfileNameWid">
                    <label className="profileLabel">GST Number</label>
                    <input
                      className="form-control"
                      placeholder={t("GST Number")}
                      type="text"
                     
                     
                    />
                  </div>
            
            
                
              </form>
              </div>
            )}
            {activeTab === "tab5" && (
              <div className="bankDetailsData">
                <BankDetails tab={activeTab}/>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
